import { ApiResourceModel } from "@auvious/common";
export var SpeechToTextProviderType;
(function (SpeechToTextProviderType) {
    SpeechToTextProviderType["GOOGLE"] = "GOOGLE";
    SpeechToTextProviderType["AMAZON"] = "AMAZON";
    SpeechToTextProviderType["MICROSOFT"] = "MICROSOFT";
    SpeechToTextProviderType["OPEN_AI"] = "OPEN_AI";
})(SpeechToTextProviderType || (SpeechToTextProviderType = {}));
export var TranslationProviderType;
(function (TranslationProviderType) {
    TranslationProviderType["GOOGLE_BASIC"] = "GOOGLE_BASIC";
    TranslationProviderType["GOOGLE_ADVANCED"] = "GOOGLE_ADVANCED";
    TranslationProviderType["AMAZON"] = "AMAZON";
    TranslationProviderType["MICROSOFT"] = "MICROSOFT";
})(TranslationProviderType || (TranslationProviderType = {}));
export class OrganizationLanguage extends ApiResourceModel {
    constructor(args = {}) {
        super();
        this.organizationLanguageId = args.organizationLanguageId;
        this.languageName = args.languageName;
        this.languageCode = args.languageCode;
        this.providerType = args.providerType;
        this.model = args.model;
        this.translateProviderType = args.translateProviderType;
    }
}
export class ProviderLanguages extends ApiResourceModel {
    constructor(args = {}) {
        super();
        this.id = args.id;
        this.languageName = args.languageName;
        this.model = args.model;
    }
}
export class TranscriptConfigurationResponse extends ApiResourceModel {
    constructor(args = {}) {
        super();
        this.transcriptId = args.transcriptId;
        this.languageCode = args.languageCode;
    }
}
export var AI_MQTT_EVENTS;
(function (AI_MQTT_EVENTS) {
    AI_MQTT_EVENTS["ASROfflineTranscriptCreatedEvent"] = "ASROfflineTranscriptCreatedEvent";
    AI_MQTT_EVENTS["ASROfflineTranslationCreatedEvent"] = "ASROfflineTranslationCreatedEvent";
    AI_MQTT_EVENTS["ASROfflineSummarizationCreatedEvent"] = "ASROfflineSummarizationCreatedEvent";
    AI_MQTT_EVENTS["ASROfflineSentimentCreatedEvent"] = "ASROfflineSentimentCreatedEvent";
    AI_MQTT_EVENTS["ASROfflineTranscriptFailedEvent"] = "ASROfflineTranscriptFailedEvent";
    AI_MQTT_EVENTS["ASROfflineTranslationFailedEvent"] = "ASROfflineTranslationFailedEvent";
    AI_MQTT_EVENTS["ASROfflineSummarizationFailedEvent"] = "ASROfflineSummarizationFailedEvent";
    AI_MQTT_EVENTS["ASROfflineSentimentFailedEvent"] = "ASROfflineSentimentFailedEvent";
})(AI_MQTT_EVENTS || (AI_MQTT_EVENTS = {}));
